import { Landmark, ShieldCheck, FileText, Zap, Globe } from "lucide-react";

const badges = [
  { Icon: Landmark, title: "Registered SA Company", sub: "Reg: 2003/034426/23" },
  { Icon: ShieldCheck, title: "Secure B2B Transactions", sub: "Protected Business Dealings" },
  { Icon: FileText, title: "Export Documentation Ready", sub: "Full Export Capability" },
  { Icon: Zap, title: "24hr Quote Response", sub: "Guaranteed Response Time" },
  { Icon: Globe, title: "Worldwide Coverage", sub: "Africa & Beyond" },
];

const TrustBadgesStrip = () => (
  <section className="bg-[#0A1628] border-y border-[#E8721C]/20" data-testid="trust-badges">
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-8">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
        {badges.map((b, i) => (
          <div
            key={b.title}
            data-testid={`trust-badge-${i}`}
            className={`flex items-start gap-3 px-3 py-4 lg:py-2 ${i > 0 ? "lg:border-l border-[#E8721C]/30" : ""}`}
          >
            <b.Icon className="text-[#E8721C] shrink-0 mt-1" size={26} strokeWidth={1.6}/>
            <div>
              <div className="font-display text-white text-[15px] md:text-[17px] tracking-wide leading-tight">{b.title}</div>
              <div className="text-[#8A96A3] text-[11px] mt-1 tracking-[.04em]">{b.sub}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustBadgesStrip;
